import { useContext, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import Context from "../Context/ApplicationContext";
import loginUser from "../Services/loginService";

export default function useUser() {
  const navigate = useNavigate();
  const { jwt, username, roles, setJwt, setUsername, setRoles, setIsLogged } =
    useContext(Context);
  const [state, setState] = useState({
    loading: false,
    error: false,
    message: "",
  });

  const login = useCallback(
    async ({ username, password }: { username: string; password: string }) => {
      setState({ loading: true, error: false, message: "" });

      try {
        const response = await loginUser({ username, password });

        if (!response || typeof response !== "object") {
          throw new Error("Usuario o contraseña incorrectos");
        }

        const token = response.token;
        const name = response.username;
        const userRoles = response.roles || [];

        if (!token || !name) {
          throw new Error("Credenciales inválidas o incompletas");
        }

        sessionStorage.setItem("jwt", token);
        sessionStorage.setItem("username", name);
        sessionStorage.setItem("roles", JSON.stringify(userRoles));

        setJwt(token);
        setUsername(name);
        setRoles(userRoles);
        setIsLogged(true);
        setState({ loading: false, error: false, message: "" });

        return true;
      } catch (error) {
        const errorMessage =
          error instanceof Error ? error.message : "Error al iniciar sesión";

        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("username");
        sessionStorage.removeItem("roles");

        setJwt(null);
        setUsername(null);
        setRoles([]);
        setIsLogged(false);
        setState({ loading: false, error: true, message: errorMessage });

        return false;
      }
    },
    [setJwt, setUsername, setRoles, setIsLogged],
  );

  const logout = useCallback(() => {
    sessionStorage.removeItem("jwt");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("roles");
    setJwt(null);
    setUsername(null);
    setRoles([]);
    setIsLogged(false);
    navigate("/login");
  }, [setJwt, setUsername, setRoles, setIsLogged, navigate]);

  return {
    isLogged: Boolean(jwt),
    isLoginLoading: state.loading,
    hasLoginError: state.error,
    message: state.message,
    login,
    logout,
    user: username,
    roles,
  };
}
